export interface SkuImageJson {
    id: number;
    ulid: string;
    sku_id: number;
    report_source_id: number | null;
    file_path: string;
    original_url: string;
    source_image_id: string | null;
    is_default: boolean;
    sort_order: number;
    url: string;
}

export default class SkuImage {
    id = 0;
    ulid = '';
    sku_id = 0;
    report_source_id: number | null = null;
    file_path = '';
    original_url = '';
    source_image_id: string | null = null;
    is_default = false;
    sort_order = 0;
    url = '';

    toJSON(): SkuImageJson {
        return Object.assign({} as SkuImageJson, this);
    }

    static fromJSON(json: SkuImageJson): SkuImage {
        const image = Object.create(SkuImage.prototype);
        return Object.assign(image, json);
    }
}
